import { render, staticRenderFns } from "./Flyers.vue?vue&type=template&id=389eb0fa&"
import script from "./Flyers.vue?vue&type=script&lang=js&"
export * from "./Flyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports